import { Checkbox, Collapse, Form, FormInstance } from 'antd';
import React, { FC } from 'react';
import { TextRegular14 } from 'styles/typography';
import TempFieldsListItem from './TempFieldsListItem';

import * as S from './TempFieldsList.styles';
import { useTranslation } from 'react-i18next';

type Props = {
  formId: string;
  fieldsArr: {
    isSelected: boolean;
    id: string;
    area: number;
    readableArea: string;
  }[];
  selectedIds: string[];
  onSubmit: (values: { [key: string]: string }) => void;
  onListItemClick: (id: string) => () => void;
  onListItemInputFocus: (id: string) => () => void;
  form: FormInstance;
  onCheckAllFields?: () => void;
};

const TempFieldsList: FC<Props> = ({
  formId,
  fieldsArr,
  selectedIds,
  onSubmit,
  onListItemClick,
  onListItemInputFocus,
  onCheckAllFields,
  form,
}) => {
  const { t } = useTranslation();

  if (Boolean(!fieldsArr.length)) {
    return null;
  }

  const getDisplayedFieldsCountText = () => (
    <TextRegular14>
      {t('Common.Displayed', 'Displayed: ')}
      {t('Field.TempFieldsList.FieldsCount', {
        count: fieldsArr.length,
        defaultValue: '{{count}} field',
      })}
    </TextRegular14>
  );

  return (
    <S.DetailsCard
      bordered={false}
      title={
        onCheckAllFields ? (
          <Checkbox
            onClick={onCheckAllFields}
            checked={selectedIds.length === fieldsArr.length}
            indeterminate={Boolean(
              !(selectedIds.length === fieldsArr.length) && selectedIds.length,
            )}
          >
            {getDisplayedFieldsCountText()}
          </Checkbox>
        ) : (
          getDisplayedFieldsCountText()
        )
      }
    >
      <Form
        form={form}
        id={formId}
        onFinish={onSubmit}
        scrollToFirstError={{ behavior: 'smooth' }}
      >
        <Collapse activeKey={selectedIds} bordered={false}>
          {fieldsArr.map(({ id, isSelected, readableArea }) => (
            <TempFieldsListItem
              key={id}
              id={id}
              isSelected={isSelected}
              onClick={onListItemClick(id)}
              onFocus={onListItemInputFocus(id)}
              readableArea={readableArea}
            />
          ))}
        </Collapse>
      </Form>
    </S.DetailsCard>
  );
};

export default TempFieldsList;
